var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60837 11.3333H13.391M8.60837 11.3333L7.33301 14M8.60837 11.3333L10.5185 7.33935C10.6725 7.01751 10.7494 6.8566 10.8547 6.80575C10.9463 6.76152 11.0531 6.76152 11.1446 6.80575C11.2499 6.8566 11.3269 7.01751 11.4808 7.33935L13.391 11.3333M13.391 11.3333L14.6663 14M1.33301 3.33333H5.33301M5.33301 3.33333H7.66634M5.33301 3.33333V2M7.66634 3.33333H9.33301M7.66634 3.33333C7.33558 5.30486 6.56807 7.09079 5.44337 8.58962M6.66634 9.33333C6.25799 9.14987 5.84144 8.89472 5.44337 8.58962M5.44337 8.58962C4.54169 7.89851 3.73485 6.95109 3.33301 6M5.44337 8.58962C4.37358 10.0153 2.98063 11.1812 1.33301 12",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/translate.73110d3341d78ef653a0976ab9de7f54.svg";
export { ForwardRef as ReactComponent };